import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Form, Row, Space, Spin, Table, Tabs, Upload } from "antd";
import { useEffect, useRef, useState } from "react";
import ModalCustom from "../../components/ModalCustom/ModalCustom";
import contract from "../../api/contract";
import Notification from "../../components/Notification";
import ListActionButton from "../../components/ListActionButton/ActionListButton";
import mammoth from "mammoth";
import InputFields from "../../components/InputFields/InputFields";
import {
  columnsTableList,
  dataFindContract,
  dataUploadTemplate,
} from "./config";
import courseApi from "../../api/course";
import Search from "../../components/Search/Search";
import { formatToCurrencyType } from "../../helper/common";
import { name } from "dayjs/locale/vi";

const TemplateContract = () => {
  const [loading, setLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const viewContract = useRef();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState();
  const addContractRef = useRef();
  const [params, setParams] = useState({
    pageNumber: 1,
    pageSize: 20,
  });
  const [dataSource, setDataSource] = useState(dataUploadTemplate);
  const [optionsCombo, setOptionsCombo] = useState([]);
  const [optionsOne, setOptionsOne] = useState([]);
  const [tempFile, setTempFile] = useState(null);
  const [comboForm] = Form.useForm();
  const [tempTextContract, setTempTextContract] = useState(null);
  const [columns, setColumns] = useState(columnsTableList);

  const findRef = useRef();

  const handleSearch = () => {
    const data = findRef.current?.getData();
    setParams({
      ...params,
      ...data,
      pageNumber: 1,
    });
  };
  const customRequest = (options) => {
    try {
      // Tạo một FormData để gửi tệp lên máy chủ

      setTempFile(options);
      setTempTextContract(options.file.name);
      Notification("success", "Đã tải file thành công");
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        "Lỗi khi tải file hoặc kích cỡ file đạt quá giới hạn"
      );
    }
    return false;
  };
  const handleUploadTemplate = async () => {
    setLoading(true);
    try {
      const value = await comboForm.validateFields();
      console.log("🚀 ~ handleUploadTemplate ~ value:", value);
      const formData = new FormData();

      if (tempFile?.file) {
        if (value?.courseId) {
          console.log(value?.courseId);

          formData.append("courseId", value.courseId ?? null);
        } else {
          formData.append("comboId", value.comboId ?? null);
        }
        formData.append("file", tempFile.file);
        await contract.uploaContract(formData);
        addContractRef.current.closeModal();
        getList();
        setTempFile(null);
        setTempTextContract(null);
        Notification("success", "Đã tải file thành công");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);

      Notification("warning", "Đã xảy ra lỗi khi tải file lên");
      console.log("🚀 ~ handleUploadTemplate ~ error:", error);
    }
  };

  const onChangePagination = (pageNumber, pageSize) => {
    setParams({ ...params, pageNumber: pageNumber, pageSize: pageSize });
  };
  // Lấy dữ liệu hợp đồng từ API và hiển thị trong bảng

  const getList = async () => {
    setLoading(true);
    try {
      const res = await contract.getListContractUpload(params);
      const newData = res.data.map((item) => {
        return { ...item, key: item.id };
      });
      setData(newData);
      setTotal(res.total);
      setLoading(false);
      Notification("success", "Lấy danh sách mẫu hợp đồng thành công");
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };

  const getListOnceCourse = async () => {
    try {
      const res = await courseApi.getListCourse(params);
      const options = Array.isArray(res.data)
        ? res.data.map((item) => {
            return {
              label: item.name,
              value: item.id,
              price: item.listPrice,
            };
          })
        : [];
      // const newDataSource = dataSource.map((field) =>
      //   field.name === "id" ? { ...field, options: options } : field
      // );

      setOptionsOne(options);
      Notification("success", "Lấy danh sách mẫu hợp đồng thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách mẫu hợp đồng không thành công");
    }
  };

  const getListComboCourse = async () => {
    try {
      const res = await courseApi.getListCombo(params);
      const options = Array.isArray(res.data)
        ? res.data.map((item) => ({
            label: item.name,
            value: item.id,
            price: item.totalListPrice,
          }))
        : [];
      // const newDataSource = dataUploadTemplate.map((field) =>
      //   field.name === "comboId" ? { ...field, options: options } : field
      // );
      setOptionsCombo(options);
      Notification("success", "Lấy danh sách mẫu hợp đồng thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách mẫu hợp đồng không thành công");
    }
  };
  const deleteContract = async (id) => {
    try {
      await contract.deleteTemplateContract(id);
      Notification("success", "Xóa mẫu hợp đồng thành công");
      getList();
    } catch (error) {
      Notification("error", "Xóa mẫu hợp đồng thất bại");
    }
  };
  const showContract = async (id) => {
    try {
      const res = await contract.getViewContractUpload(id);
      const arrayBuffer = res.data;
      const result = await mammoth.convertToHtml({ arrayBuffer });
      const html = result.value;
      setFileUrl(html);
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };

  const onChange = (key) => {
    const options =
      key === "1"
        ? {
            options: optionsOne,
            label: "Khóa lẻ",
            name: "courseId",
          }
        : {
            options: optionsCombo,
            label: "Combo",
            name: "comboId",
          };

    const newDataSource = dataUploadTemplate.map((field) =>
      field.name === "courseId"
        ? {
            ...field,
            ...options,
          }
        : field
    );
    setDataSource(newDataSource);
  };
  const items = [
    {
      key: "1",
      label: "Khóa lẻ",
    },
    {
      key: "2",
      label: "Combo",
    },
  ];

  useEffect(() => {
    const newColumns = columnsTableList.map((e) => {
      if (e.key === "stt") {
        return {
          ...e,
          render: (text, record, index) =>
            (params.pageNumber - 1) * params.pageSize + index + 1,
        };
      }

      if (e.key === "comboId") {
        return {
          ...e,
          render: (text, record) => {
            const itemOne = optionsOne.find(
              (item) => item.value === record.courseId
            );
            if (itemOne) return itemOne.label;

            const itemCombo = optionsCombo.find(
              (item) => item.value === record.comboId
            );
            if (itemCombo) return itemCombo.label;

            return record.comboId;
          },
        };
      }

      if (e.key === "totalListPrice") {
        return {
          ...e,
          render: (text, record) => {
            const itemOne = optionsOne.find(
              (item) => item.value === record.courseId
            );
            if (itemOne) return formatToCurrencyType(itemOne.price);

            const itemCombo = optionsCombo.find(
              (item) => item.value === record.comboId
            );
            if (itemCombo) return formatToCurrencyType(itemCombo.price);

            return record.comboId;
          },
        };
      }

      if (e.key === "action") {
        return {
          ...e,
          render: (_, record) => (
            <ListActionButton
              deleteFunction={() => deleteContract(record.id)}
              showDetailFunction={() => {
                showContract(record.id);
                viewContract.current.openModal();
              }}
            />
          ),
        };
      }

      return e;
    });

    setColumns(newColumns);
  }, [optionsOne, optionsCombo, params]);

  useEffect(() => {
    const newDataSource = dataUploadTemplate.map((field) =>
      field.name === "courseId"
        ? {
            ...field,
            options: optionsOne,
          }
        : field
    );

    setDataSource(newDataSource);
  }, [optionsOne]);

  useEffect(() => {
    getListComboCourse();
    getListOnceCourse();
  }, []);

  useEffect(() => {
    getList();
  }, [params]);

  return (
    <Spin spinning={loading}>
      <div
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            handleSearch();
          }
        }}
        className="container"
      >
        <Search
          fields={dataFindContract}
          onClickSearch={handleSearch}
          ref={findRef}
        />
      </div>
      <div className="container">
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Row justify="space-between">
            <div className="title">Danh sách mẫu hợp đồng</div>
            <Button
              icon={<PlusOutlined />}
              onClick={() => addContractRef.current.openModal()}
              type="primary"
            >
              Tải tài liệu mới
            </Button>
          </Row>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              pageSize: params.pageSize,
              current: params.pageNumber,
              onChange: onChangePagination,
            }}
            bordered
          />
          <ModalCustom ref={viewContract} title="Chi tiết hợp đồng">
            {/* <MyDocViewer fileUrl={fileUrl} /> */}
            <div dangerouslySetInnerHTML={{ __html: fileUrl }} />
          </ModalCustom>
          <ModalCustom title="Tải lên mẫu hợp đồng" ref={addContractRef}>
            <Spin spinning={loading}>
              <Space
                direction="vertical"
                size="large"
                style={{ width: "100%" }}
              >
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
                <Form form={comboForm}>
                  <Row gutter={[16, 8]}>
                    <InputFields data={dataSource} />
                  </Row>
                </Form>
                {tempTextContract ? (
                  <Row justify={"space-between"}>
                    <div style={{ fontWeight: "bold" }}>
                      Hợp đồng: {tempTextContract}
                    </div>
                    <Upload
                      customRequest={customRequest}
                      accept=".docx"
                      multiple
                      showUploadList={false}
                    >
                      <Button
                        type="primary"
                        className="btn-sub"
                        icon={<UploadOutlined rev={undefined} />}
                      >
                        Tải lại hợp đồng mẫu
                      </Button>
                    </Upload>
                  </Row>
                ) : (
                  <Upload
                    customRequest={customRequest}
                    accept=".docx"
                    multiple
                    showUploadList={false}
                  >
                    <Button
                      type="primary"
                      className="btn-sub"
                      icon={<UploadOutlined rev={undefined} />}
                    >
                      Tải hợp đồng mẫu
                    </Button>
                  </Upload>
                )}
                <Row justify={"end"}>
                  <Space đirection="horizontal" size="small">
                    <Button type="primary" onClick={handleUploadTemplate}>
                      Tải lên
                    </Button>
                    <Button
                      danger
                      onClick={() => {
                        addContractRef.current.closeModal();
                        comboForm.resetFields();
                      }}
                    >
                      Hủy
                    </Button>
                  </Space>
                </Row>
              </Space>
            </Spin>
          </ModalCustom>
        </Space>
      </div>
    </Spin>
  );
};

export default TemplateContract;
